import React from 'react';
import { Box, Typography } from '@mui/material';
import { ScheduleSection } from '../types';
import { getSubjectColor } from '../subjectColors';
import useStyles from '../styles';

type SectionCellProps = {
  sections: ScheduleSection[];
  onSectionClick: (sectionId: number, mipreuId: number) => void;
};

function SectionCell({ sections, onSectionClick }: SectionCellProps) {
  const classes = useStyles();

  if (sections.length === 0) {
    return <Typography className={classes.emptyCell}>Disponible</Typography>;
  }

  return (
    <>
      {sections.map((section) => (
        <Box
          key={`section-${section.sectionId}`}
          className={classes.sectionCard}
          style={{ backgroundColor: getSubjectColor(section.subjectName, section.subjectId) }}
          onClick={() => onSectionClick(section.sectionId, section.mipreuId)}
          sx={{ cursor: 'pointer' }}
        >
          <Typography className={classes.sectionNumber}>
            {section.mipreuId}
          </Typography>
          <Typography className={classes.sectionText}>
            {section.programName}
          </Typography>
          <Typography className={classes.sectionText}>
            {section.teachers.length > 0 ? section.teachers.join(' / ') : 'Sin profesor'}
          </Typography>
          <Typography className={classes.sectionText}>
            {section.studentsCount}
          </Typography>
        </Box>
      ))}
    </>
  );
}

export default SectionCell;
